import { graphql } from "react-relay"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { useChDeletePatientSocialSecurityNumberMutation as TMutation } from "@/modules/patients/services/ch/__generated__/useChDeletePatientSocialSecurityNumberMutation.graphql"

const mutation = graphql`
  mutation useChDeletePatientSocialSecurityNumberMutation($input: Ch_deletePatientSocialSecurityNumberInput!) {
    ch_deletePatientSocialSecurityNumber(input: $input) {
      ch_Patient {
        id
        socialSecurityNumber
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useChDeletePatientSocialSecurityNumberMutation = () => useMutationWithErrorToast<TMutation>(mutation)
